export const MANAGE_ACCOUNT_LINK = 'https://accounts.bluebeam.com';
export const BLUEBEAM_LINK = 'https://bluebeam.com';
export const GATEWAY_LINK = 'https://portal.bluebeam.com';
export const CLOUD_LINK = 'https://app.bluebeam.com';
export const WEBSTORE_LINK = 'https://www.bluebeam.com/solutions/compare';
export const SUPPORT_LINK = 'http://support.bluebeam.com';
export const CONTACT_LINK = 'https://www.bluebeam.com/company/contact-us';
